<script setup lang="ts">
/**
 * GameExitScreen — 玩家在遊戲內按離開後的「已退出」全屏頁。
 *
 * 觸發：Cocos 送 `EXIT_GAME`（postMessage）→ App.vue 把 `gameExited` 翻 true。
 * 蓋在最上層（z-20、白底），底下的 Cocos iframe 不再顯示。
 *
 * 「返回遊戲」按鈕不自己做導頁，emit `return` 交給 App.vue 處理
 * （目前實作 = `window.location.reload()`，等於重新走一次登入流程）。
 *
 * 文案走 i18n `exit.*`（title / desc / button）。
 */
import { useI18n } from 'vue-i18n'
import ExitAvatar from '../assets/exit-avatar.webp'

const { t } = useI18n()

const emit = defineEmits<{
  /** 按下「返回遊戲」 */
  return: []
}>()
</script>

<template>
  <section class="relative z-20 grid h-full place-items-center bg-white p-6">
    <div class="flex flex-col items-center gap-6 text-center">
      <img :src="ExitAvatar" alt="avatar" class="h-40 w-32 rounded-full object-cover" />
      <div>
        <p class="m-0 mb-2 text-[19px] font-bold text-gray-800">
          {{ t('exit.title') }}
        </p>
        <p class="m-0 text-sm text-gray-500">
          {{ t('exit.desc') }}
        </p>
      </div>
      <button
        class="cursor-pointer bg-[#EEEDF2] px-16 py-3 text-[12px] text-base transition-colors hover:bg-gray-50 active:bg-gray-100"
        @click="emit('return')"
      >
        {{ t('exit.button') }}
      </button>
    </div>
  </section>
</template>
